import React from "react";
import { Form, Button, Select, Space } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { getTranslation } from "../../../utils/helper";

const { Option } = Select;

const RouteTimeSpeedForm = ({ setting, driverId, speed, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  const handleOnFinish = speed => {
    onSubmit({ driver: driverId, speed });
  };

  return (
    <Form form={form} initialValues={{ speed }}>
      <Space>
        <Form.Item name="speed" rules={[{ required: true, message: "Required" }]} style={{ margin: 0, minWidth: 82 }}>
          <Select onSelect={handleOnFinish}>
            {/* <Option value="X2SLOWER">
              {getTranslation(setting, "Drivers", "X2 Slower")}
            </Option>
            <Option value="SLOWER">
              {getTranslation(setting, "Drivers", "Slower")}
            </Option> */}
            <Option value="SLOW">{getTranslation(setting, "Drivers", "Slow")}</Option>
            <Option value="NORMAL">{getTranslation(setting, "Drivers", "Normal")}</Option>
            <Option value="FAST">{getTranslation(setting, "Drivers", "Fast")}</Option>
            {/* <Option value="FASTER">
              {getTranslation(setting, "Drivers", "Faster")}
            </Option>
            <Option value="X2FASTER">
              {getTranslation(setting, "Drivers", "X2 Faster")}
            </Option> */}
          </Select>
        </Form.Item>
        <Button icon={<CloseCircleOutlined style={{ color: "#888888" }} />} onClick={onCancel} className="btn-cancel" />
      </Space>
    </Form>
  );
};

export default RouteTimeSpeedForm;
